export default "__VITE_ASSET__3M3asqS0__"